import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormGroup, Validators } from '@angular/forms'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { distinctUntilChanged, startWith } from 'rxjs/operators'

@Component({
  selector: 'app-security-deposit-form',
  templateUrl: './security-deposit-form.component.html',
  styleUrls: ['./security-deposit-form.component.scss'],
})
export class SecurityDepositFormComponent extends Destroyable implements OnInit {
  @Input() currencyCode: string
  @Input() form: FormGroup

  @Output() change = new EventEmitter()

  get amountPlaceholder() {
    return this.form.get('type').value === 'pct'
      ? $localize`Amount` + ' (%)'
      : $localize`Amount` + ' (' + this.currencyCode + ')'
  }

  constructor() {
    super()
  }

  ngOnInit() {
    this.form.valueChanges.pipe(untilDestroy(this)).subscribe((values) => {
      this.change.emit(values)
    })

    this.form
      .get('type')
      .valueChanges.pipe(startWith(this.form.get('type').value), distinctUntilChanged(), untilDestroy(this))
      .subscribe((type) => {
        if (type === 'pct') {
          this.form.get('amount').setValidators([Validators.required, Validators.min(1), Validators.max(100)])
        } else {
          this.form.get('amount').setValidators([Validators.required, Validators.min(1)])
        }
        this.form.get('amount').updateValueAndValidity()
      })
  }
}
